import { useDayPicker } from 'react-day-picker';

import { Button } from '@/components/common';

export const CustomFooter = () => {
  const dayPicker = useDayPicker();

  const goToCurrent = () => {
    const today = new Date();
    dayPicker.goToMonth(today);
  };

  return (
    <div className="flex justify-center pt-s">
      <Button
        variant="secondary"
        size="sm"
        borderRadius="square"
        onClick={goToCurrent}
        className="text-brand-primary-base border-none"
      >
        Today
      </Button>
    </div>
  );
};
